/**
 * NotificationItem Component
 * Displays individual notification with actions
 */
import React from 'react';
import cn from 'classnames';
import { Notification } from '../../types/notification.types';
import Button from '../UI/button';
import { Trash2 } from 'lucide-react';
import './NotificationItem.css';

interface NotificationItemProps {
  notification: Notification;
  onMarkAsRead: (id: string) => void;
  onDelete: (id: string) => void;
  onClick?: (notification: Notification) => void;
}

export const NotificationItem: React.FC<NotificationItemProps> = ({
  notification,
  onMarkAsRead,
  onDelete,
  onClick
}) => {
  const handleClick = () => {
    if (!notification.read) {
      onMarkAsRead(notification._id);
    }
    onClick?.(notification);
  };

  const formattedDate = new Date(notification.createdAt).toLocaleDateString();
  const isInvitation = notification.type === 'TRIP_INVITE';

  return (
    <li className={cn('notification-item', { unread: !notification.read })}>
      <div className='notification-item-content'>
        <div className='notification-item-info'>
          <div className='notification-item-owner'>
            <span>{formattedDate}</span>
          </div>
          <div
            onClick={handleClick}
            style={{ cursor: 'pointer' }}
          >
            <p
              style={{ fontWeight: 500, marginBottom: '4px', fontSize: '14px' }}
            >
              {notification.title}
            </p>
            <p style={{ fontSize: '14px' }}>{notification.message}</p>
          </div>
        </div>
      </div>
      {isInvitation ? (
        <div className='notification-item-actions'>
          <Button
            variant='dark'
            size='sm'
            onClick={handleClick}
          >
            View
          </Button>
          <Button
            variant='outline-dark'
            size='sm'
            onClick={handleClick}
          >
            More Info
          </Button>
          <Button
            variant='link'
            className='text-primary p-0'
            height='auto'
            onClick={() => onDelete(notification._id)}
          >
            Dismiss
          </Button>
        </div>
      ) : (
        <div className='notification-item-actions'>
          <div className='d-flex align-items-center gap-2 flex-grow-1'>
            {!notification.read && (
              <Button
                variant='primary'
                size='sm'
                onClick={() => onMarkAsRead(notification._id)}
              >
                Mark as Read
              </Button>
            )}
          </div>
          <Button
            variant='transparent'
            height={20}
            width={20}
            className='p-0'
            onClick={() => onDelete(notification._id)}
            title='Delete notification'
          >
            <Trash2
              size={16}
              className='text-danger'
            />
          </Button>
        </div>
      )}
    </li>
  );
};
